// Copyright (C) 2019-2022 Intel Corporation
// Copyright (C) 2022 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

const config = {
    backendAPI: '/api',
    organizationID: null,
    origin: '',
    uploadChunkSize: 100,
    removeUnderlyingMaskPixels: false,
};

export default config;
